import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import emailjs from 'emailjs-com'; // Import EmailJS

// Custom marker icon
const customIcon = new L.Icon({
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  shadowSize: [41, 41],
});

function Contact() {
  const [messageSent, setMessageSent] = useState(false);
  const [error, setError] = useState(false);

  const position = [19.8762, 75.3433]; // Replace with your latitude and longitude

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    
    // Send WhatsApp message
    const formData = new FormData(form);
    const name = formData.get('name');
    const phone = formData.get('phone');
    const email = formData.get('email');
    const message = formData.get('message');

    const whatsappMessage = `Hello, I am ${name}. Phone: ${phone}. Email: ${email}. Message: ${message}`;
    const whatsappUrl = `https://api.whatsapp.com/send?phone=+919657579144&text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, '_blank');

    // Send email
    emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form, 'YOUR_USER_ID')
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        setMessageSent(true);
      }, (error) => {
        console.log('Error sending email:', error.text);
        setError(true);
      });
  };

  return (
    <div style={{ fontFamily: "'Roboto', sans-serif" }}>
      <section className='section' style={{ padding: '50px 0', background: 'linear-gradient(to bottom, #f5f7fa, #c3cfe2)' }}>
        <div className='container'>
          <div className='card shadow' style={{ borderRadius: '12px', padding: '20px', background: '#ffffff' }}>
            <div className='card-body'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <h6 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>Contact Us</h6>
                    <hr />
                    <div className='form-group'>
                      <label htmlFor="name" className='mb-1'>Full Name:</label>
                      <input type="text" name="name" placeholder='Enter Full Name' className='form-control' style={{ borderRadius: '8px', padding: '10px' }} required />
                    </div>
                    <div className='form-group'>
                      <label htmlFor="phone" className='mb-1'>Phone Number:</label>
                      <input type="tel" name="phone" pattern="[0-9]{10}" placeholder='Enter Phone Number' className='form-control' style={{ borderRadius: '8px', padding: '10px' }} required />
                    </div>
                    <div className='form-group'>
                      <label htmlFor="email" className='mb-1'>Email Address:</label>
                      <input type="email" name="email" placeholder='Enter Email address' className='form-control' style={{ borderRadius: '8px', padding: '10px' }} required />
                    </div>
                    <div className='form-group'>
                      <label htmlFor="message" className='mb-1'>Message:</label>
                      <textarea name="message" rows="3" className='form-control' placeholder='Type your message...' style={{ borderRadius: '8px', padding: '10px' }} required></textarea>
                    </div>
                    <div className='form-group py-3'>
                      <button type='submit' className='btn btn-primary shadow' style={{ width: '100%', padding: '12px', borderRadius: '8px', background: 'linear-gradient(45deg, #1e3c72, #2a5298)', border: 'none', color: '#fff', fontSize: '16px' }}>
                        Send Message
                      </button>
                      {messageSent && <p style={{ color: 'green', marginTop: '10px' }}>Message sent successfully!</p>}
                      {error && <p style={{ color: 'red', marginTop: '10px' }}>There was an error sending your message.</p>}
                    </div>
                  </div>

                  <div className='col-md-6 border-start'>
                    <h5 className='main-heading' style={{ fontSize: '20px', fontWeight: '600', marginBottom: '20px' }}>
                      Address Information
                    </h5>
                    <p style={{ fontSize: '16px', marginBottom: '10px' }}>Chhatrapati Sambhaji Nagar, Maharashtra, India</p>
                    <p style={{ fontSize: '16px', marginBottom: '10px' }}>+91 9657579144</p>
                    <p style={{ fontSize: '16px', marginBottom: '10px' }}>smartjet96@gmail.com</p>
                    
                    {/* Leaflet Map */}
                    <MapContainer center={position} zoom={13} style={{ height: '400px', width: '100%', borderRadius: '12px', marginBottom: '20px' }}>
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      <Marker position={position} icon={customIcon}>
                        <Popup>
                          Chhatrapati Sambhaji Nagar, Maharashtra, India
                        </Popup>
                      </Marker>
                    </MapContainer>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
